import React, { useState, useEffect, useRef } from "react";
import BaseLayout from "./BaseLayout";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../api";
import { useAuth } from "../context/AuthContext";
import axios from "axios";

const SignUpPage = ({ isAuthenticated, user }) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password1, setPassword] = useState("");
  const [password2, setPasswordConfirm] = useState("");
  const [message, setMessage] = useState({ type: "", content: "" });
  const navigate = useNavigate();
  const { setAuthData } = useAuth();
  const [honeypot, setHoneypot] = useState("");
  const loadTime = useRef(Date.now());

  useEffect(() => {
    localStorage.removeItem("token");
    setAuthData({ isAuthenticated: false, token: null });
    //console.log("Authentication state cleared");
  }, [setAuthData]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage({ type: "", content: "" });

    if (honeypot) {
      setMessage({ type: "success", content: "Account created successfully! Logging you in..." });
      return;
    }
    if (Date.now() - loadTime.current < 3000) {
      setMessage({ type: "error", content: "Please slow down." });
      return;
    }
    const nameRegex = /^[a-zA-Z\u00C0-\u017E\s'-]{1,50}$/;
    const urlPattern = /https?:\/\/|www\.|bit\.ly|\.com|\.net|\.org|\.io/i;
    const emojiPattern = /[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}]/u;
    for (const [field, value] of [["First name", firstName], ["Last name", lastName]]) {
      if (!nameRegex.test(value) || urlPattern.test(value) || emojiPattern.test(value)) {
        setMessage({ type: "error", content: `${field} contains invalid characters.` });
        return;
      }
    }

    if (password1 !== password2) {
      setMessage({ type: "error", content: "Passwords do not match." });
      return;
    }

    if (password1.length < 8) {
      setMessage({
        type: "error",
        content: "Password must be at least 8 characters long.",
      });
      return;
    }

    try {
      const signUpResponse = await axios.post(`${API_BASE}/sign-up`, {
        email,
        firstName,
        lastName,
        password1,
        password2,
      });

      if (signUpResponse.status === 200) {
        const loginResponse = await axios.post(`${API_BASE}/login`, {
          email,
          password: password1,
        });
        const { access_token, user } = loginResponse.data;

        setMessage({
          type: "success",
          content: "Account created successfully! Logging you in...",
        });
        setTimeout(() => {
          localStorage.setItem("token", access_token);
          localStorage.setItem("user", JSON.stringify(user));
          setAuthData({ isAuthenticated: true, token: access_token, user: user });
  
          navigate('/home');
        }, 1500);
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.error
          : "An error occurred. Please try again.";
      setMessage({ type: "error", content: errorMessage });
    }
  };

  return (
    <BaseLayout isAuthenticated={isAuthenticated} user={user}>
      <div align="center">
        <img
          src="/loginlogo.png"
          style={{ width: "400px", height: "auto" }}
          alt="Avatar"
          className="avatar"
        />
      </div>
      <div align="center">
      </div>
      <div>
        {message.content && (
          <div
            className={`alert ${
              message.type === "error" ? "alert-danger" : "alert-success"
            }`}
            role="alert"
          >
            {message.content}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="hp-field">
            <input
              type="text"
              name="website"
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
              tabIndex={-1}
              autoComplete="off"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              className="form-control input-default-font"
              id="email"
              name="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              className="form-control input-default-font"
              id="firstName"
              name="firstName"
              placeholder="Enter first name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              className="form-control input-default-font"
              id="lastName"
              name="lastName"
              placeholder="Enter last name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password1">Password</label>
            <input
              type="password"
              className="form-control input-default-font"
              id="password1"
              name="password1"
              placeholder="Enter password"
              value={password1}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password2">Password (Confirm)</label>
            <input
              type="password"
              className="form-control input-default-font"
              id="password2"
              name="password2"
              placeholder="Re-enter password"
              value={password2}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
          </div>
          <br />
          <button type="submit" className="btn custom-btn-green">
            <i className="fa fa-fw fa-user"></i>Create Account
          </button>
        </form>
      </div>
    </BaseLayout>
  );
};

export default SignUpPage;
